import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import HowToSetup1 from "../components/HowToSetup";

const HowToSetup = () => {
    return (
        <>
            <Header />
            <main>
                <HowToSetup1/>
                <Footer />
            </main>
            <Scrolltop />
        </>
    );
};

export default HowToSetup;
